import { useQuery } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

interface MyDetailsData {
  active?: { staff?: boolean; student?: boolean; carer?: boolean };
  permissions?: { group_admin?: boolean; [key: string]: unknown };
  /** The caller's numeric Edumate ContactId as exposed by pymble-apis'
   *  user/my/details/ response (same field PresetDetail's owner check
   *  reads). */
  contact_id?: number;
  /** The caller's numeric Edumate ContactId, stringified. Historical field
   *  name from the SMS integration, but it is the only place /my/details/
   *  exposes the numeric id client-side (same source the portal's preset
   *  components read - see my-pymble-portal PresetCard.tsx). */
  SmsId?: string | number;
  /** Not returned by /my/details/ today, but the auth-side user object
   *  carries this shape; kept optional so a future response addition is
   *  picked up without a cast. */
  foreign_keys?: { edumate_contact_id?: number; [key: string]: unknown };
  [key: string]: unknown;
}

export function useMyDetails() {
  const { callApi, isAuthenticated } = usePymbleApi();

  const query = useQuery({
    queryKey: ["my-details"],
    queryFn: () => callApi("GET", "/my/details/") as Promise<MyDetailsData>,
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 30,
    retry: 1,
  });

  const hasAdminAccess =
    query.data?.active?.staff === true &&
    query.data?.permissions?.group_admin === true;

  return {
    user: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    hasAdminAccess,
  };
}
